import { ProductCustomizationModifiers } from '../../product-customization/product-customization-modifiers';

import { ProductItemFlowContainer } from './styled';

interface IProductItemFlowProps {}

export const ProductItem: React.FC<IProductItemFlowProps> = () => {
  return (
    <ProductItemFlowContainer testID="product-item-flow">
      <ProductCustomizationModifiers />
    </ProductItemFlowContainer>
  );
};
